import _toConsumableArray from '/var/www/html/node_modules/babel-runtime/helpers/toConsumableArray';
import _typeof from '/var/www/html/node_modules/babel-runtime/helpers/typeof';
import _regeneratorRuntime from '/var/www/html/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/var/www/html/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import autosize from 'autosize';
import axios from "axios";
import $ from 'jquery';

import Store from '~/components/assistant/Store.vue';
import AssistantStore from '~/components/assistant/AssistantStore.vue';

export default {
  layout: "assistant",
  head: function head() {
    var titleTemplate = this.mode == 'chatbot' ? this.$root.trans('st_public.chat_with', { name: this.botName }) : this.$root.trans('st_public.chat_with_assistant', { name: this.formatedAssistantName });
    return {
      titleTemplate: titleTemplate
    };
  },
  data: function data() {
    return {
      isToday: false,
      day: '',
      time: 0,
      start_time: 0,
      end_time: 0,
      text: '',
      botName: "",
      botPhone: "",
      personName: this.$root.trans('st_public.You'),
      botMessages: [],
      level: 0,
      disableSendMessage: true,
      messages: [],
      download: false,
      countdown: 0,
      flow: 1,
      mode: null,
      currentDayIndex: 0,
      deeplink: null,
      country_code: null,
      utm_info: null,
      screenHeight: 0,
      intervalId: 0,
      previousHeight: 0,
      mounted: true,
      os: null,
      os_version: null,
      show_call_button: false,
      forwarding_active_code: null,
      contact_name: '',
      formatedAssistantName: null
    };
  },

  components: {
    'store': Store,
    'assistant-store': AssistantStore
  },
  asyncData: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          route = _ref.route;

      var id, token, lang, _ref3, data, chat_conversation, level, flowSpecification;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              id = route.params.id;
              token = route.params.token;
              lang = route.params.lang;


              if (!id || !token) {
                error({ statusCode: 404, message: 'Page not found' });
              }
              _context.next = 6;
              return axios.get(global.getEndPoint() + ('api/web_chat/' + lang + '/' + id + '/' + token));

            case 6:
              _ref3 = _context.sent;
              data = _ref3.data;
              chat_conversation = data.data.chat_conversation == null ? [] : data.data.chat_conversation;
              level = chat_conversation.filter(function (elm) {
                return elm.side == 'left';
              });
              flowSpecification = chat_conversation.find(function (elm) {
                return elm.flow;
              });
              return _context.abrupt('return', {
                botMessages: data.data.chats,
                messages: chat_conversation,
                level: level.length,
                botName: data.call_receiver_name,
                botPhone: data.data.phone,
                flow: flowSpecification ? flowSpecification.flow : 1,
                deeplink: data.deeplink,
                country_code: data.country_code.toLowerCase(),
                utm_info: data.utm_info
              });

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function asyncData(_x) {
      return _ref2.apply(this, arguments);
    }

    return asyncData;
  }(),
  mounted: function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var id, token, response, result;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              id = this.$root._route.params.id;
              token = this.$root._route.params.token;
              _context2.next = 4;
              return axios.post(global.getEndPoint() + ('api/web_chat/' + id + '/' + token + '/start'));

            case 4:
              response = _context2.sent;
              result = response.data;

              this.countdown = result.remaining_time;
              this.mode = result.mode;
              this.forwarding_active_code = result.data.extra_info ? result.data.extra_info.forwarding_active_code ? result.data.extra_info.forwarding_active_code : this.botPhone : this.botPhone;
              this.contact_name = result.data.extra_info ? result.data.extra_info.is_contact ? result.data.extra_info.contact_name : '' : '';
              this.mounted = false;
              if (this.level != this.publishBotMessages.length) this.botResponse();
              autosize(this.$refs.textarea);
              this.getListOfHours();
              this.updateCountdown();
              this.scollChat();
              this.screenHeight = window.innerHeight + 'px';
              this.previousHeight = window.innerHeight;
              this.checkOS(navigator.userAgent);
              this.getMobileOSVersionFromUserAgent(navigator.userAgent);
              if (this.publishBotMessages.length == this.level) this.show_call_button = true;
              this.delayedUpdateInfo();

            case 22:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _ref4.apply(this, arguments);
    }

    return mounted;
  }(),

  computed: {
    firstName: function firstName() {
      var nameRules = this.nameRules(this.botName);
      return nameRules;
    },
    publishBotMessages: function publishBotMessages() {
      var _this = this;

      var init = this.botMessages[0];
      var filterBotMessages = this.botMessages.filter(function (elm) {
        return elm.flow == _this.flow;
      });
      var filterLink = this.botMessages.find(function (elm) {
        return elm.type == 'link';
      });
      return [init].concat(filterBotMessages).concat([filterLink]);
    },
    lang: function lang() {
      return this.$root._route.params.lang;
    }
  },
  methods: {
    delayedUpdateInfo: function delayedUpdateInfo() {
      var _this2 = this;

      var id = this.$root._route.params.id;
      var token = this.$root._route.params.token;
      var lang = this.lang;
      setTimeout(function () {
        var payload = _this2.utm_info;
        payload['os'] = _this2.os;
        payload['os_version'] = _this2.os_version;
        axios.post(global.getEndPoint() + ('api/web_chat/update-info/' + lang + '/' + id + '/' + token), payload).then(function (response) {
          _this2.deeplink = response.data.deeplink;
        });
      }, 500);
    },
    getMobileOSVersionFromUserAgent: function getMobileOSVersionFromUserAgent(userAgent) {
      // Regular expressions to match mobile operating systems
      var androidRegex = /Android\s([\d.]+)/;
      var iosRegex = /iPhone OS (\d+[._]\d+)/;
      var macRegex = /Mac OS X (\d+([._]\d+)*)/;
      var windowsRegex = /Windows NT (\d+\.\d+)/;

      // Check for Android
      if (androidRegex.test(userAgent)) {
        this.os_version = userAgent.match(androidRegex)[1];
      }
      // Check for iOS
      else if (iosRegex.test(userAgent)) {
          this.os_version = userAgent.match(iosRegex)[1].replace(/_/g, ".");
        } else if (macRegex.test(userAgent)) {
          this.os_version = userAgent.match(macRegex)[1].replace(/_/g, ".");
        }
        // Check for Windows
        else if (windowsRegex.test(userAgent)) {
            this.os_version = userAgent.match(windowsRegex)[1];
          }
          // If no match is found
          else {
              this.os_version = "Unknown";
            }
    },
    checkOS: function checkOS(userAgent) {
      var androidRegex = /Android/;
      var iosRegex = /(iPhone|iPad|iPod)/;
      var macRegex = /Macintosh/;
      var windowsRegex = /Windows/;
      var linuxRegex = /Linux/;

      this.show_call_button = true;

      if (androidRegex.test(userAgent)) {
        this.os = 'android';
      } else if (iosRegex.test(userAgent)) {
        this.os = 'ios';
      } else if (macRegex.test(userAgent)) {
        this.os = 'macOS';
      } else if (windowsRegex.test(userAgent)) {
        this.os = "Windows";
      } else if (linuxRegex.test(userAgent)) {
        this.os = "Linux";
      } else {
        this.os = 'Unknown';
      }
    },
    findNestedValue: function findNestedValue(obj, targetKey) {
      for (var key in obj) {
        if (key === targetKey) {
          return obj[key];
        } else if (_typeof(obj[key]) === 'object') {
          var result = this.findNestedValue(obj[key], targetKey);
          if (result !== undefined) {
            return result;
          }
        }
      }
      return undefined;
    },
    updateDeeplinkFrom: function updateDeeplinkFrom(key) {
      var id = this.$root._route.params.id;
      var token = this.$root._route.params.token;
      axios.post(global.getEndPoint() + ('api/web_chat/update-deeplink_from/' + id + '/' + token), {
        deeplink_click_from: key
      });
    },
    sortedDays: function sortedDays(days) {
      var today = new Date().getDay();

      var daysAfterToday = days.slice(today);
      var daysBeforeToday = days.slice(0, today);

      var sortedDays = [].concat(_toConsumableArray(daysAfterToday), _toConsumableArray(daysBeforeToday));
      return sortedDays;
    },
    nameRules: function nameRules(name) {
      var rules = ['abo', 'abu', 'om', 'em', 'ابو', 'أبو', 'ام', 'أم'];
      var splitWord = name.split(" ");
      var firstWord = splitWord[0];
      var secondWord = splitWord[1];
      if (rules.includes(firstWord.toLowerCase())) {
        if (secondWord) return firstWord + ' ' + secondWord;
        return firstWord;
      }
      return firstWord;
    },
    formatedName: function formatedName(item) {
      var nameRules = this.nameRules(item.name);
      var apostrophe = this.lang == 'en' ? "\'s" : '';
      var formatedName = item.side == 'left' ? nameRules + apostrophe : nameRules;
      this.formatedAssistantName = formatedName;
      return formatedName;
    },
    displayFirstWordAndFirstCharOfSecondWord: function displayFirstWordAndFirstCharOfSecondWord(inputString) {
      // Split the input string into words based on spaces
      var words = inputString.split(' ');

      if (words.length > 1) {
        // If there is more than one word, extract the first word
        var firstWord = words[0];

        var firstCharSecondWord = words[1].charAt(0);
        var maskedRest11 = '*'.repeat(words[1].length - 1);

        // Create a mask of asterisks for the rest of the words
        var maskedRest = words.slice(2).map(function (word) {
          return '*'.repeat(word.length);
        });

        // Reconstruct the string with the first word displayed and the rest masked
        var unmaskedString = firstWord + ' ' + firstCharSecondWord + maskedRest11 + ' ' + maskedRest.join(' ');
        return unmaskedString;
      } else {
        // If there is only one word, return the original string
        return inputString;
      }
    },
    getListOfHours: function getListOfHours() {
      var findIsToday = this.findNestedValue(this.messages, 'isToday');
      var findDay = this.messages.find(function (elm) {
        return elm.text.isDay == true;
      });
      if (findDay) {
        this.start_time = findDay.text.startTime;
        this.end_time = findDay.text.endTime;
      }
      if (findIsToday) this.isToday = true;
      var now = new Date();
      var startTime = new Date(now);
      var listOfHours = this.isToday ? now.getHours() + 2 : this.start_time;
      startTime.setHours(listOfHours);

      var hoursRange = [];

      for (var i = 0; i <= 23; i += 1) {
        var hour = new Date(startTime);
        if (startTime.getHours() + i >= this.start_time && startTime.getHours() + i <= this.end_time) {
          hour.setHours(startTime.getHours() + i);

          var formattedHour = hour.getHours().toString().padStart(2, '0') + ':00';

          hoursRange.push(formattedHour);
        }
      }
      var findIsTimeIndex = this.botMessages.findIndex(function (elm) {
        return elm.isTime;
      });
      if (findIsTimeIndex >= 0) this.botMessages[findIsTimeIndex].options = hoursRange;
    },
    chooseOption: function chooseOption(option) {
      this.flow = option.id;
      this.text = this.$root.trans('st_public.' + option.info);
      this.sendMessage([], option.id);
    },
    chooseDay: function chooseDay(day, index, id) {
      var findIndex = this.messages.findIndex(function (elm) {
        return elm.id == id;
      });
      this.messages[findIndex].hide = true;
      this.text = index == this.currentDayIndex ? this.$root.trans('st_public.Today') : this.$root.trans('st_public.' + day);
      this.start_time = this.messages[findIndex].text.startTime;
      this.end_time = this.messages[findIndex].text.endTime;
      this.isToday = index == this.currentDayIndex;
      this.day = this.text;
      this.sendMessage({ isToday: this.isToday });
      this.getListOfHours();
    },
    chooseTime: function chooseTime(time, index, id) {
      var findIndex = this.messages.findIndex(function (elm) {
        return elm.id == id;
      });
      this.messages[findIndex].hide = true;
      this.text = time;
      this.time = this.text;
      this.sendMessage();
    },
    updateCountdown: function updateCountdown() {
      if (this.countdown > 0) {
        this.countdown--;
        setTimeout(this.updateCountdown, 1000); // Update countdown every second
      } else {
        // Countdown has reached zero, you can perform any action here
        if (this.mode == 'chatbot') this.download = true;
      }
    },
    formatTime: function formatTime(seconds) {
      var minutes = Math.floor(seconds % 3600 / 60);
      var remainingSeconds = seconds % 60;
      var formattedTime = minutes + ':' + (remainingSeconds < 10 ? '0' : '') + remainingSeconds;

      return formattedTime;
    },
    currentDate: function currentDate() {
      var months = [this.$root.trans('st_public.Jan'), this.$root.trans('st_public.Feb'), this.$root.trans('st_public.Mar'), this.$root.trans('st_public.Apr'), this.$root.trans('st_public.May'), this.$root.trans('st_public.June'), this.$root.trans('st_public.July'), this.$root.trans('st_public.Aug'), this.$root.trans('st_public.Sep'), this.$root.trans('st_public.Oct'), this.$root.trans('st_public.Nov'), this.$root.trans('st_public.Dec')];
      var currentDate = new Date();
      var year = currentDate.getFullYear();
      var month = months[currentDate.getMonth()];
      var day = String(currentDate.getDate()).padStart(2, '0');
      return day + ' ' + month + ' ' + year;
    },
    onBlur: function onBlur(event) {
      var _this3 = this;

      setTimeout(function () {
        _this3.screenHeight = window.innerHeight + 'px';
        window.scrollTo(0, 0);
      }, 100);

      if (/(iPhone|iPad)/i.test(navigator.userAgent)) {} else {
        // clearInterval(this.intervalId);
      }
    },
    onTap: function onTap() {
      var _this4 = this;

      var element = document.getElementById("msger-header-info");
      var rect = element.getBoundingClientRect();
      setTimeout(function () {
        if (_this4.mode == 'chatbot') {
          var top = /(iPhone|iPad)/i.test(navigator.userAgent) ? 285 : 0;
          window.scrollTo(0, top);
        } else {
          var _top = rect.top;
          var isKeypadAndroid = _this4.os == 'android' ? 200 : 0;
          if (_this4.os == 'android') _this4.screenHeight = window.innerHeight - (isKeypadAndroid + _top) + 'px';else _this4.screenHeight = window.innerHeight + (isKeypadAndroid + _top) + 'px';
          element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        }
      }, 500);

      if (/(iPhone|iPad)/i.test(navigator.userAgent)) {} else {
        // this.intervalId = setInterval(this.checkKeyboardStatus, 200); // You can adjust the interval as needed
      }
    },
    checkKeyboardStatus: function checkKeyboardStatus() {
      var currentHeight = window.innerHeight;

      if (currentHeight < this.previousHeight) {
        setTimeout(function () {
          var top = 285;
          top = top + 15;
          window.scrollTo(0, top);
        }, 500);
      } else if (currentHeight > this.previousHeight) {
        // Keyboard is closed
        window.scrollTo(0, 0);
      }

      this.previousHeight = currentHeight;
    },
    onPressEnter: function onPressEnter() {
      var textarea = document.getElementById('msger-input');
      var cursorPosition = textarea.selectionStart;

      // Move the cursor position after the inserted <br> tag
      textarea.selectionStart = cursorPosition + 4;
      textarea.selectionEnd = cursorPosition + 4;
    },
    sendMessage: function sendMessage() {
      var _this5 = this;

      var addition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var flow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!this.text) return;
      if (this.publishBotMessages.length > this.level) {
        if (this.level == 1) {
          if (flow == null) this.flow = 3;
        }

        var uuid = this.uuidv4();
        this.messages.push({
          id: uuid,
          side: 'right',
          name: this.personName,
          text: this.text.replace(/\n/g, "<br />"),
          isLoading: true,
          flow: this.flow,
          more: addition
        });
        this.appendMessage(uuid);
        this.storeMessages();
        this.text = '';
        setTimeout(function () {
          _this5.botResponse();
        }, 400);
        this.removeAllInlineStyles(document.getElementById('msger-input'));
      }
    },
    botResponse: function botResponse() {
      var _this6 = this;

      this.disableSendMessage = true;
      var uuid = this.uuidv4();
      var msgText = this.publishBotMessages[this.level];
      var translation_key = 'st_public.' + msgText.info;
      if (this.contact_name != '') {
        translation_key = 'st_public.' + msgText.info + '_with_contact';
      }
      msgText.info = this.$root.trans(translation_key, { caller: this.contact_name, name: this.firstName, time: this.time, day: this.day });
      this.messages.push({
        id: uuid,
        side: 'left',
        name: this.botName,
        text: msgText,
        isLoading: true
      });

      this.scollChat();

      setTimeout(function () {
        _this6.appendMessage(uuid);
        _this6.disableSendMessage = !msgText.allow_chat;
        _this6.level++;
        if (_this6.level == _this6.publishBotMessages.length) _this6.storeMessages();
        if (_this6.isFlowFinish(msgText)) {
          _this6.finish();
        }
      }, 3000);
    },
    finish: function finish() {
      var _this7 = this;

      this.botResponse();
      if (this.os == 'ios' && this.mode == 'assistant') {
        setTimeout(function () {
          _this7.call();
        }, 4000);
      }
    },
    call: function call() {
      var phoneNumber = this.forwarding_active_code;
      window.location.href = 'tel:' + phoneNumber;
      this.updateDeeplinkFrom('ASSISTANT_CALL');
    },
    storeMessages: function storeMessages() {
      var id = this.$root._route.params.id;
      var token = this.$root._route.params.token;
      this.messages = this.messages.map(function (elm) {
        elm.isLoading = false;
        return elm;
      });
      axios.post(global.getEndPoint() + ('api/web_chat/' + id + '/' + token), this.messages);
    },
    uuidv4: function uuidv4() {
      return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function (c) {
        return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
      });
    },
    isFlowFinish: function isFlowFinish(msgText) {
      if (msgText.auto_generate_store_url) return true;
      return false;
    },
    appendMessage: function appendMessage(uuid) {
      this.messages = this.messages.map(function (elm) {
        if (elm.id == uuid) elm.isLoading = false;
        return elm;
      });
      this.scollChat();
    },
    scollChat: function scollChat() {
      setTimeout(function () {
        document.getElementById('msger-chat').scrollTop += 500;
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }, 0);
    },
    removeAllInlineStyles: function removeAllInlineStyles(element) {
      // Check if the element is valid
      if (!element || !element.style) {
        return;
      }

      // Loop through each inline style and remove it
      var inlineStyles = element.style;
      for (var i = 0; i < inlineStyles.length; i++) {
        var propertyName = inlineStyles[i];
        element.style.removeProperty(propertyName);
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/assistant/_id/_token.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/assistant/_id/_token.vue
// module chunks = 10